import {
    SET_HAPPINESS_TIPS,
    SET_HAPPINESS_TIPS_DELETE
} from "./types/mutations.js";

const mutations = {
    [SET_HAPPINESS_TIPS]: (state, payload) => {
        state.happinessTips = payload;
    },
    [SET_HAPPINESS_TIPS_DELETE]: (state, payload) => {
        state.happinessTips = state.happinessTips.filter(item => item.idTip !== payload);
    }
};

export default mutations;
